<script lang="ts"></script>

<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [QR Panel]
 * Плитка QR-кода
 */

// Hooks
import useTranslate from "@/hooks/useTranslate/useTranslate.js";

// Types
import type { I_QRPanel } from "./qrPanel.types.js";

const props = defineProps<I_QRPanel>();
</script>

<template>
    <div data-component="qrPanel" class="tiw__qrPanel">
        <figure class="tiw__qrPanel__figure">
            <img class="tiw__qrPanel__image" :src="props.qrPreview || ''" alt="QR Code" />
        </figure>
        <div class="tiw__qrPanel__body">
            <b class="tiw__qrPanel__title">
                {{ useTranslate("tiw__qrPanel__title") }}
            </b>
            <p class="tiw__text tiw__qrPanel__text">
                {{ useTranslate("tiw__qrPanel__info") }}
            </p>
        </div>
    </div>
</template>

<style lang="scss" src="./qrPanel.scss"></style>
